import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SmoothScroll from './components/SmoothScroll';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Divisions from './pages/Divisions';
import Services from './pages/Services';
import Terms from './pages/Terms';
import RiskDisclosure from './pages/RiskDisclosure';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NDAPolicy from './pages/NDAPolicy';
import Careers from './pages/Careers';
import Apply from './pages/Apply';
import Pricing from './pages/Pricing';
import SecretLogos from './pages/SecretLogos';
import SecretData from './pages/SecretData';

const AppContent = () => {
  const location = useLocation();
  const hideFooter = location.pathname === '/about' || 
                    location.pathname === '/divisions' || 
                    location.pathname === '/services' ||
                    location.pathname === '/careers' ||
                    location.pathname === '/pricing' ||
                    location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/divisions" element={<Divisions />} />
          <Route path="/services" element={<Services />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/risk-disclosure" element={<RiskDisclosure />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/nda-policy" element={<NDAPolicy />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/apply/:position" element={<Apply />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/secret-logos" element={<SecretLogos />} />
          <Route path="/secret-data" element={<SecretData />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <SmoothScroll>
        <AppContent />
      </SmoothScroll>
    </Router>
  );
}

export default App;